export const translationDynamicValues = (brandName: string) => ({
  BRAND: brandName,
});
